import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import config from "../../../config/config.json";
import { apiCall } from "../../../services/ApiCall";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }
    const { isSuccess, data } = await apiCall(
      `${config.AUTH_API_URL}verifyPasswordResetToken`,
      {},
      { token, password },
      "POST"
    );
    setMessage(data?.message || "Something went wrong.");
    if (isSuccess) {
      setTimeout(() => navigate("/"), 2000);
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", backgroundColor: "rgba(0, 80, 164, 1)" }}>
      <div style={{ backgroundColor: "rgba(26, 77, 143, 0.95)", borderRadius: "16px", padding: "2rem", width: "100%", maxWidth: "400px", textAlign: "center" }}>
        <h2 style={{ color: "white" }}>Set New Password</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="New Password"
            style={{ width: "100%", padding: "12px", marginBottom: "1rem", borderRadius: "8px" }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <input
            type="password"
            placeholder="Confirm New Password"
            style={{ width: "100%", padding: "12px", marginBottom: "1rem", borderRadius: "8px" }}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <button type="submit" style={{ padding: "12px 24px", borderRadius: "8px", border: "none", cursor: "pointer" }}>
            Reset Password
          </button>
        </form>
        {message && <p style={{ color: "white", marginTop: "1rem" }}>{message}</p>}
      </div>
    </div>
  );
}

export default ResetPassword;
